export default __webpack_public_path__ + "static/media/CFBJJ400x400.ee74dee4.jpg";